import { __ } from '@wordpress/i18n';
import './Header.css';

const Header = ({ onSaveAll, onResetAll }) => {
  return (
    <header className="hvnly-settings-api__header">
      <div className="hvnly-settings-api__logo">
        <h1>{__('Havenlytics Settings', 'havenlytics')}</h1>
      </div>
      <div className="hvnly-settings-api__actions">
        <button 
          className="hvnly-settings-api__btn hvnly-settings-api__btn--secondary"
          onClick={onResetAll}
        >
          <i className="fas fa-sync-alt"></i> {__('Reset All', 'havenlytics')}
        </button>
        <button 
          className="hvnly-settings-api__btn hvnly-settings-api__btn--primary"
          onClick={onSaveAll}
        >
          <i className="fas fa-save"></i> {__('Save All Settings', 'havenlytics')}
        </button>
      </div>
    </header>
  );
};

export default Header;